export const topBarHeight = 64;
export const sideNavWidth = 260;
export const navbarHeight = 60;
export const sidenavCompactWidth = 80;
export const containedLayoutWidth = 1200;
export const broilerId = "d8105474-c5f7-4981-a435-32b307b6ee22";
export const layerId = "f89e98ef-7dfb-42a9-aa17-c822c0b5797e";
export const sonaliId = "6921262d-9457-4ba3-ae1a-1b43a955200f";
export const fieldOfficerRoleId = "130ADB81-C149-4981-9F51-502EF8C13907";
